import { render, staticRenderFns } from "./SimpleCardList.vue?vue&type=template&id=45dc9ba0&scoped=true"
import script from "./SimpleCardList.vue?vue&type=script&lang=js"
export * from "./SimpleCardList.vue?vue&type=script&lang=js"
import style0 from "./SimpleCardList.vue?vue&type=style&index=0&id=45dc9ba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dc9ba0",
  null
  
)

export default component.exports